import type { ReactNode } from 'react';

interface Props {
  /** Already translated. Components never pass a raw Error here. */
  message: string;
  tone?: 'danger' | 'warning';
  action?: ReactNode;
}

/**
 * The only way this feature shows a failure. `role="alert"` so a screen reader
 * hears it the moment it appears — a booking that silently fails is worse than
 * one that never started.
 */
export function ErrorNotice({ message, tone = 'danger', action }: Props) {
  const styles =
    tone === 'warning'
      ? 'border-warning bg-warning-soft text-warning'
      : 'border-danger bg-danger-soft text-danger';

  return (
    <div
      role="alert"
      className={`flex flex-col gap-2 rounded-token border px-3 py-2 text-sm sm:flex-row sm:items-center sm:justify-between ${styles}`}
    >
      <span>{message}</span>
      {action && <span className="shrink-0">{action}</span>}
    </div>
  );
}
